<script>
import { mapState } from 'vuex';
import VisitLocationsService from '@/services/VisitLocationsService';

export default {
  name: 'VisitLocationModal',
  props: {
    existing: {
      type: Object,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      visitLocation: {
        name: null,
        social_table_count: null,
      },
      useCustomTableCount: false,
      submitting: false,
    };
  },
  computed: {
    ...mapState({
      prison: state => state.prison.prison,
    }),
  },
  mounted() {
    if (this.existing) {
      this.visitLocation = { ...this.existing };
    }
  },
  methods: {
    async submitForm() {
      try {
        this.submitting = true;
        if (this.visitLocation.social_table_count !== null) {
          this.visitLocation.social_table_count = Number(this.visitLocation.social_table_count);
        }
        if (this.existing) {
          await VisitLocationsService.updateVisitLocation(this.existing._id, this.visitLocation);
        } else {
          await VisitLocationsService.createVisitLocation(this.visitLocation);
        }
        this.$emit('refresh');
      } catch (e) {
        console.error(`Error ${this.existing ? 'updating' : 'creating'} visit location: `, e);
        this.$toast.error(`Error ${this.existing ? 'updating' : 'creating'} visit location. Please try again.`, {
          toastClassName: ['toast-std', 'warning-toast'],
        });
      } finally {
        this.submitting = false;
      }
    },
    // isValid() {
    //   if (!this.existing) {
    //     return this.visitLocation.name && this.visitLocation.social_table_count;
    //   }
    //   return this.visitLocation.name;
    // },
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
  },
}
</script>

<template>
  <validation-observer ref="observer" v-slot="{ handleSubmit, invalid }">
    <b-form @submit.stop.prevent="handleSubmit(submitForm)">
      <b-form-group>
        <b-row>
          <b-col cols="12" class="mb-1">
            <validation-provider
              v-slot="validationContext"
              name="Name"
              :rules="{required:true}"
            >
              <label>Name</label>
              <b-form-input
                v-model="visitLocation.name"
                required label="Name"
                cy="name"
                placeholder="Enter name"
                :state="getValidationState(validationContext)"
              />
            </validation-provider>
          </b-col>
          <b-col cols="12" class="mb-1">
            <validation-provider
              v-slot="validationContext"
              name="Table Count"
              :rules="{required:true, min_value: 1}"
            >
              <label>Table count</label>
              <b-form-input
                v-model="visitLocation.social_table_count"
                :required="useCustomTableCount"
                placeholder="Enter a table count"
                type="number"
                :state="getValidationState(validationContext)"
              />
            </validation-provider>
          </b-col>
        </b-row>

        <section class="d-flex full-width my-1">
          <div class="ui-spacer" />
          <button
            class="btn btn-danger mr-2"
            @click="$emit('close')"
          >
            Cancel
          </button>
          <button
            class="btn btn-primary"
            type="submit"
            :class="{'disabled' : submitting || invalid }"
          >
            {{ existing && existing._id ? 'Update' : 'Add' }} Visit Location
          </button>
        </section>
      </b-form-group>
    </b-form>
  </validation-observer>
</template>
